export const readQueryParamString = (name: string): string | null => {
  if (typeof window === "undefined") return null;
  const params = new URL(window.location.href).searchParams;
  return params.get(name) ?? "";
};

export const readQueryParamNumber = (name: string): number | null => {
  const numAsString = readQueryParamString(name);
  const num = Number.parseInt(numAsString ?? "", 10);
  return Number.isNaN(num) ? null : num;
};
